module.exports = __webpack_public_path__ + "static/media/18.a25591e2.jpg";